module.exports = __webpack_public_path__ + "static/img/sj.89c6f935.png";